/**
 * Sign in scene
 * 
 * @author Mautilus s.r.o.
 * @class Scene_Account
 * @extends Scene
 */

Scene_Account = (function(Scene) {

	var Scene_Account = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Scene_Account.prototype, Scene.prototype, {
		/**
		 * @inheritdoc Scene#init
		 */
		init: function(){
			console.log('[Scene] init ' + this.name + ' scene');

			this.dontRedraw = false; // prevent to redraw scene

			this.snippetAccount = new Snippet_Account(this, {});
		},
		
		/**
		 * @inheritdoc Scene#create
		 */
		create: function() {
			return $('#scene-account');
		},
		
		/**
		 * @inheritdoc Scene#activate
		 */
		activate: function() {
			App.throbber();
			return new Promise(function (resolve, reject) {
				this.getSubscriptionData()
					.bind(this)
					.then(function(data) {
						console.log(data);
						$('#subtitle-sub').text(data);
						App.throbberHide(false);
						resolve();
					})
					.catch(function(err) {
						console.log(err);
						App.throbberHide(false);
						reject(err);
				});
			}.bind(this));
		},
		
		/**
		 * @inheritdoc Scene#render
		 */
		render: function() {
			this.snippetAccount.render();
		},

		getSubscriptionData: function(){
			return new Promise(function (resolve, reject){
				API.getUserSubscription()
					.bind(this)
					.then(function (data) {
						console.log(data);
					var subscriptionName = __("sub_inactive");
					var subscriptionItem = data.data.me.userSuscriptionPlans.find(item => item.is_valid && item.suscriptionPlan.type != 'PPV')
					if(data.data.me.userSuscriptionPlans.find(item => item.is_valid && item.suscriptionPlan.type != 'PPV')){
					  	hasSubscriptionPlan = true;
						subscriptionName = subscriptionItem.suscriptionPlan.name;
					}

					resolve(subscriptionName);
				});
			}.bind(this));
		},

		/**
		 * @inheritdoc Scene#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Scene#onEnter
		 */
		onEnter: function($el, event) {
		},
		/**
		 * @inheritdoc Scene#onReturn
		 */
		onReturn: function($el, event) {
			if ( App.dialog ) {
				App.dialog.onClose();
				return false;
			}
			Router.goBack();
			return false;
		},
		/**
		 * @inheritdoc Scene#navigate
		 */
		navigate: function(direction) {
		},
		
		/**
		 * @inheritdoc Scene#focus
		 */
		focus: function() {
			// Focus.to(this);
		},
		
		/**
		 * @inheritdoc Scene#onBeforeGoBack
		 */
		onBeforeGoBack: function(fromScene) {
			this.dontRedraw = true;
		},
		
		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Scene
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		}

	});

	return Scene_Account;

})(Scene);


//////////////////
// WEBPACK FOOTER
// ./js/scene/account.js
// module id = 53
// module chunks = 0